import React, {useEffect, useState} from 'react';
import {
    changeBottomNavigation,
    changeTitle,
    setRoutePresentation,
    setStateGoBackUrl,
    showMenuNavBar
} from "../../actions";
import {connect} from "react-redux";
import {withTranslation} from 'react-i18next';
import {compose} from 'redux';
import {useRoute, useRouteUnlock} from "../../hooks/useRoute";
import useStoredRouteUpdate from "../../hooks/useStoredRouteUpdate";
import Constants from "../../config/constants";
import ErrorRequestHandler from "../../components/ErrorRequestHandler";
import VoieComponent from "../../components/Route/VoieComponent";
import SecteurComponent from "../../components/Route/SecteurComponent";
import DetailsComponent from "../../components/Route/DetailsComponent";
import ApproachComponent from "../../components/Route/ApproachComponent";
import {useUser} from "../../hooks/useUser";
import {useAuth} from "../../context/auth-context";
import {useMatomo} from "@datapunt/matomo-tracker-react";
import useSEO from "../../hooks/useSEO";
import {useParams} from "react-router-dom";
import {getUrl, PWAUrls, PWAUrlsParams} from "../../config/urls";
import {toast} from "react-toastify";

const RouteScreen = (props) => {
    const {t, i18n, onTitleChange, onBottomNavigationChange, onShowMenuNavBar, setGoBackUrl, routeListOrigin, details: propDetails, approach: propApproach, setRoutePresentation} = props;
    const {slugsecteur, slugvoie} = useParams();
    const [unlocked, setUnlocked] = useState(true);
    const auth = useAuth();
    const details = typeof propDetails !== "undefined" && propDetails;
    const approach = typeof propApproach !== "undefined" && propApproach;
    const currentPath = window.location.pathname;
    let slug = null;
    let type = null;

    if (slugsecteur) {
        slug = slugsecteur;
        type = Constants.TypeTopo.FALAISE;
    }
    if (slugvoie) {
        type = Constants.TypeTopo.GRANDEVOIE;
        slug = slugvoie;
    }

    const {data: userData} = useUser(auth.user?.email, i18n.language);
    const user = userData?.user ? userData.user : {};
    const { status, data, error } = useRouteUnlock(i18n.language, type, slug, unlocked, user);
    const routePrivate = data;

    if ((unlocked && status === "error" && !data) || (unlocked && !auth.isAuthenticated)) {
        setUnlocked(false);
    }

    if (data?.id && !unlocked) {
        setUnlocked(true);
    }

    let route = data;
    const { status: statusPublic, data: dataPublic, error: errorPublic } = useRoute(i18n.language, type, slug, unlocked);

    if (statusPublic === "success" && status !== "success" && !route?.id) {
        route = dataPublic;
    }

    // if (route?.slug && route.slug !== slug) {
    //     if (type === Constants.TypeTopo.FALAISE) {
    //         console.log("reload", slug, match.params, route?.slug, statusPublic);
    //         window.location.replace(window.location.href.replace(
    //             new RegExp( '\\/' + slugregion +  '\\/' + slugfalaise + '\\/' + slug),
    //             '/' + route?.regionSlug + '/' + route?.groupRouteSlug + '/' + route.slug
    //         ));
    //     }
    //     if (type === Constants.TypeTopo.GRANDEVOIE) {
    //         window.location.replace(window.location.href.replace(
    //             new RegExp( '\\/' + slugregion + '\\/' + slug),
    //             '/' + route?.regionSlug + '/' + route.slug
    //         ));
    //     }
    // }

    const { trackPageView } = useMatomo();

    useEffect(() => {
        setRoutePresentation(window.location.pathname);
    }, [slugsecteur, slugvoie]);

    useEffect(() => {
        const title = (route?.label) ? route.label : "";
        onTitleChange(title);

        onShowMenuNavBar(false);

        if (title !== "") {
            trackPageView({
                documentTitle: title, // optional
                href: window.location.pathname,
            });
        }

    }, [t, onTitleChange, onBottomNavigationChange, onShowMenuNavBar]);

    useEffect(() => {
        const url = new URL(window.location.href);
        if (details || approach) {
            onBottomNavigationChange(false);
        } else {
            onBottomNavigationChange(true);
        }

        if (details) {
            setGoBackUrl(currentPath.replace('/' + PWAUrlsParams.details[i18n.language], ''));
        } else if (approach) {
            setGoBackUrl(currentPath.replace('/' + PWAUrlsParams.approach[i18n.language], ''));
        } else if (url.searchParams.has('tick')) {
            setGoBackUrl(getUrl(PWAUrls.TICKING_VIEW, {lng: i18n.language, id: url.searchParams.get('tick')}));
        } else {
            if (type === Constants.TypeTopo.FALAISE) {
                const backUrl = currentPath.replace(new RegExp( '/' + slugsecteur + '$'), '');
                setGoBackUrl(backUrl);
            }

            if (type === Constants.TypeTopo.GRANDEVOIE) {
                setGoBackUrl(routeListOrigin);
            }
        }
    }, [details, approach]);

    if (route?.label || status === "success" || statusPublic === "success") {
        const title = (route?.label) ? route.label : "";
        onTitleChange(title);

        if (title !== "") {
            trackPageView({
                documentTitle: title, // optional
                href: window.location.pathname,
            });
        }
    }

    const {mutateAsync, status: statusSaving, error: errorSaving } = useStoredRouteUpdate(i18n.language);

    useSEO({noIndex: (details || approach) && status !== 'success' && !routePrivate?.id });

    const saveRoute = async () => {
        try {
            await mutateAsync({
                id: route.id,
                action: 'add',
            });
        } catch (e) {
            toast.error(t('common.error.save'));
        }
    }

    const unsaveRoute = async () => {
        try {
            await mutateAsync({
                id: route.id,
                action: 'remove',
            });
        } catch (e) {
            toast.error(t('common.error.delete'));
        }

    }

    if (!route?.id && (status === "pending" || statusPublic === "pending")) {
        return (<div className={"loadingWrapper"}>
            <div id="loading"/>
        </div>);
    }

    if (details || approach) {
        if (status === "success" && routePrivate?.id) {
            if (details) {
                return (
                    <div className="container px-0">
                        <div className={"flexColumnCenter detailsScreen"} style={{height: '100%'}}>
                            <DetailsComponent
                                route={route}
                                type={type}
                            />
                        </div>
                    </div>);
            }

            if (approach) {
                return (<div className="container px-0">
                    <div className={"flexColumnCenter detailsScreen"} style={{height: '100%'}}>
                        <ApproachComponent
                            approachImg={route?.approach_big_url}
                            route={route}
                        />
                    </div>
                </div>);
            }

        }

        //Do not show error if we have data...
        if (status === 'error') {
            if (route?.id) {
                return (<ErrorRequestHandler
                    error={error}
                    ctaLabel={t('AlertComponent.button.backToUrl', {label: route.label})}
                    ctaLinkTo={window.location.pathname.replace(/\/(details|approche)$/g, '')}
                    ctaIcon={"arrow-left"}
                />);
            } else {
                return (<ErrorRequestHandler
                    error={error}
                />);
            }
        }
    }

    if (route?.id && (status === 'success'
        || statusPublic === "success")) {
        if (type === Constants.TypeTopo.FALAISE) {
            return (<div className="container-lg secteurScreen">
                <SecteurComponent isOnly={false}
                                  secteur={route}
                                  saveRoute={saveRoute}
                                  unsaveRoute={unsaveRoute}
                                  error={errorSaving}
                                  status={statusSaving}
                                  unlock={unlocked}
                />
                {/*{(!approach || !details) && <div style={{height: "57px"}} />}*/}
            </div>);
        }

        if (type === Constants.TypeTopo.GRANDEVOIE) {
            return (<div className="container-lg lieuScreen">
                <VoieComponent voie={route}
                               saveRoute={saveRoute}
                               unsaveRoute={unsaveRoute}
                               error={errorSaving}
                               status={statusSaving}
                               unlock={unlocked}
                />
                {/*{(!approach || !details) && <div style={{height: "57px"}} />}*/}
            </div>);
        }
    }

    if (statusPublic === 'error' && errorPublic) {
        return (<ErrorRequestHandler error={errorPublic}/>);
    }

    return (<></>);
}
const mapStateToProps = (state) => {
    return {
        routeListOrigin: state.navbar.routeListOrigin,
    };
}

const mapDispatchToProps = dispatch => {
    return {
        onTitleChange: (title) => {
            dispatch(changeTitle(title))
        },
        onBottomNavigationChange: (icons) => {
            dispatch(changeBottomNavigation(icons))
        },
        onShowMenuNavBar: (showMenuNavBarBool) => {
            dispatch(showMenuNavBar(showMenuNavBarBool))
        },
        setRoutePresentation: (url) => {
            dispatch(setRoutePresentation(url))
        },
        setGoBackUrl: (url, params) => {
            dispatch(setStateGoBackUrl(url, params))
        },
    }
}

export default compose(
        withTranslation(),
        connect(
            mapStateToProps,
            mapDispatchToProps
        ))(RouteScreen);